<template>
  <div class="ok-service-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/ok/banner.png"
      />

      <div
        class="section-container info-box wow animate__fadeIn"
        data-wow-duration="300ms"
        data-wow-delay="200ms"
      >
        <p class="title">
          欢迎拨打24小时服务热线<br /><span>400-823-5566</span>
        </p>
        <p class="info">新希望地产400客服<br />为你真诚服务<br /></p>
        <div class="button" @click="goPage">
          <p>立即探索</p>
        </div>
      </div>
      <div class="bottom-box">
        <div class="bottom-text">
          <p>新 希 望 地 产 OK 天 使</p>
          <p>CUSTOMER SERVICE</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OkServicePage",
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
      // 手动触发滚动事件
      const event = new Event('scroll');
      window.dispatchEvent(event);
    });
  },
  methods: {
    goPage() {
      this.$router.push({
        name: 'OkInfo'
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.ok-service-container {
  position: relative;

  .info-box {
    top: 0;
    left: 50%;
    margin-left: -585px;
    position: absolute;
    height: 100%;
    box-sizing: border-box;
    padding: 140px 0 0 8%;
    color: #fff;

    .title {
      font-size: 30px;

      > span {
        color: #fef001;
        font-size: 36px;
      }
    }

    .info {
      font-size: 16px;
      line-height: 32px;
      margin-top: 50px;
    }
  }

  .button {
    width: 85px;
    height: 30px;
    border: 1px solid #fff;
    outline: none;
    color: #fff;
    font-size: 13px;
    line-height: 30px;
    font-weight: 400;
    border-radius: 1px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    text-align: center;
    position: relative;
    margin-top: 50px;

    &::before {
      content: "";
      width: 0;
      height: 100%;
      transition: all 0.3s ease-in-out;
      background-color: #fff;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }

    &:hover {
      > p {
        color: #565c61;
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      &::before {
        width: 100%;
      }
    }
  }

  .bottom-box {
    box-sizing: border-box;
    padding: 26.5px 0;

    .bottom-text {
      text-align: center;
      color: #3c4347;

      >p {
        &:first-child {
          font-size: 18px;
          margin-bottom: 15px;
        }

        &:nth-child(2) {
          font-size: 12px;
          letter-spacing: 12px;
        }
      }
    }
  }
}
</style>
